"use client";
'use strict';

var React = require('react');
var SelectedLocationProvider = require('../providers/SelectedLocationProvider.js');

function useSelectedLocation() {
    const selectedLocation = React.useContext(SelectedLocationProvider.SelectedLocationContext);
    return selectedLocation;
}

exports.useSelectedLocation = useSelectedLocation;
//# sourceMappingURL=useSelectedLocation.js.map
